import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import IconAdd from "../componentsStyled/icon/iconadd";
import { Box } from "@mui/material";
import { isMobile } from "react-device-detect";

interface ImageUploadProps {
  onImageUpload: (file: any, index: number) => void;
  index: number;
  photoExist: string;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ onImageUpload, index, photoExist }) => {
  const [imageSrc, setImageSrc] = React.useState<string | null>(photoExist);

  const onDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      const selectedFile = acceptedFiles[0];
      onImageUpload(selectedFile, index);

      // Display the dropped image
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result as string);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: 5 * 1024 * 1024,
    onDropRejected: (rejectedFiles) => {
      console.log("rejectedFiles", rejectedFiles);
      if (rejectedFiles.length > 0) {
        const error = rejectedFiles[0].errors[0];
        if (error.code === "file-too-large") {
          alert("File is too large. Maximum size is 5 MB.");
        } else if (error.code === "file-invalid-type") {
          alert("Invalid file type. Only PNG and JPEG are allowed.");
        }
      }
    },
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpeg", ".jpg"],
    },
  });

  async function imageUrlToBase64(url) {
    try {
      const response = await fetch(url); // Fetch the image data from the URL
      const blob = await response.blob(); // Convert the response to a Blob

      // Create a new File object from the Blob
      const file = new File([blob], `image${index}.png`, { type: "image/png" });
      return file;
    } catch (error) {
      console.error("Error converting image URL to File:", error);
      return null;
    }
  }

  const convertImage = async () => {
    if (!photoExist) return;
    if (String(photoExist).includes("api.")) {
      const blob = await imageUrlToBase64(photoExist);
      onImageUpload(blob, index);
      return;
    }
    const file = new File([Uint8Array.from(atob(photoExist), (m) => m.codePointAt(0))], `image${index}.png`, { type: "image/png" });
    onDrop([file]);
  };

  useEffect(() => {
    onImageUpload(null, index);
    setTimeout(() => {
      convertImage();
    }, 500);
  }, [photoExist]);

  return (
    <div
      {...getRootProps()}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F3F3F3",
        borderRadius: 10,
        height: isMobile ? 40 : 90,
        width: isMobile ? 40 : 90,
        padding: 5,
      }}>
      {imageSrc ? (
        <img
          src={imageSrc}
          alt="Uploaded"
          style={{ height: "100%", width: "100%", objectFit: "contain" }}
          onClick={() => {
            setImageSrc(null);
            onImageUpload(null, index);
          }}
        />
      ) : (
        <Box sx={{ cursor: "pointer" }}>
          <input {...getInputProps()} style={{ display: "none" }} name={`evidences[${index}]`} />
          <IconAdd width={isMobile ? 30 : 60} />
        </Box>
      )}
    </div>
  );
};

export default ImageUpload;
